import '@babel/polyfill'
import 'url-search-params-polyfill'
import React from 'react'
import App from './app/App'
import { unregister } from './registerServiceWorker';
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { StripeProvider } from 'react-stripe-elements';
import store from './app/store'
import ScrollToTop from './app/ScrollToTop'
// import Amplify from 'aws-amplify'
import Amplify from '@aws-amplify/core';
import Auth from '@aws-amplify/auth'
import config from './config'
import AWSAppSyncClient, { createAppSyncLink } from 'aws-appsync'
import { ApolloProvider } from 'react-apollo'
import { AUTH_TYPE } from 'aws-appsync/lib/link/auth-link'
import { ApolloLink } from 'apollo-link'
import { setContext } from 'apollo-link-context'
import { createHttpLink } from 'apollo-link-http'

Amplify.configure({

  Auth: {
    mandatorySignIn: true,
    region: config.cognito.COGNITO_REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID
  }
  // , Storage: {
  //   region: config.s3.REGION,
  //   bucket: config.s3.BUCKET,
  //   identityPoolId: config.cognito.IDENTITY_POOL_ID
  // },
  // aws_appsync_graphqlEndpoint: 'https://imoyaodvrba3llikzvgpgkdqsy.appsync-api.us-west-2.amazonaws.com/graphql',
  // aws_appsync_region: 'us-east-1',
  // aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  // aws_appsync_apiKey: config.apiGateway.APIKEY,
  // API: {
  //   graphql_headers: async () => ({
  //     "x-api-key" : config.apiGateway.APIKEY
  //   }),
  //   aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  //   graphql_endpoint: "https://4t2kd774wzc4rdrpjsn65uxxz4.appsync-api.us-west-2.amazonaws.com/graphql",
  // }
})

// Setting up the AppSync client to be used with apollo
// when communicating with GraphQl
const AppSyncConfig = {
  url: config.cognito.graphqlEndpoint,
  region: config.cognito.APP_SYNC_REGION,
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => (
      await Auth.currentSession() // Retrieving token from Auth after user login
        .then(data => {
          // Required when you use Cognito UserPools OR OpenID Connect. token object is obtained previously
          return data.getIdToken().getJwtToken()
        })
        .catch(err => {
          return err
        }))
  }
}
const client = new AWSAppSyncClient(AppSyncConfig, {
  link: createAppSyncLink({
    ...AppSyncConfig,
    resultsFetcherLink: ApolloLink.from([
      setContext((request, previousContext) => {
        return {
          headers: {
            ...previousContext.headers,
            tenantID: previousContext.tenantID || localStorage.getItem('tenant') || null
          }
        }
      }),
      createHttpLink({
        uri: AppSyncConfig.url
      })
    ])
  })
})

unregister();
render(
  <Provider store={store}>
    <BrowserRouter>
      <ScrollToTop>
        <ApolloProvider client={client}>
          <StripeProvider apiKey={config.STRIPE_KEY || null}>
            <App />
          </StripeProvider>
        </ApolloProvider>
      </ScrollToTop>
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js